import { headers } from './requestConfig';
import { notificationsList } from '../service/links';

export const getNotifications = async () => {
  const response = await fetch(notificationsList, {
    method: 'GET',
    headers,
    credentials: 'include',
  });
  return response;
};
